import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkles, Bot, UserCheck, Briefcase, ArrowRight } from "lucide-react";

const ICONS = { "ai-starter": Bot, "expert-consultation": UserCheck, "project-advisory": Briefcase };

export default function PlansPreview() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    fetch(`${API}/plans/preview`).then((r) => r.json()).then((d) => Array.isArray(d) && setCards(d)).catch(() => {});
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-6 py-16 lg:py-20" data-testid="plans-preview">
      <div className="text-center max-w-2xl mx-auto">
        <p className="text-sm font-semibold uppercase tracking-wider text-[#0E9AC8]">Need Human Expertise?</p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Construction Advisory Plans</h2>
        <p className="mt-4 text-slate-500">Use NCIS for fast construction intelligence. When you need deeper guidance, connect with a construction expert — an optional escalation layer, always independent and zero commission.</p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map((c, i) => {
          const Icon = ICONS[c.slug] || Sparkles;
          return (
            <div key={c.slug} data-testid={`preview-card-${i}`}
              className="card-premium rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#0E9AC8]/60">
              <div className="h-12 w-12 rounded-xl bg-[#0E9AC8]/10 text-[#0E9AC8] flex items-center justify-center">
                <Icon className="h-6 w-6" strokeWidth={1.6} />
              </div>
              <h3 className="mt-5 font-display text-xl font-extrabold text-slate-900">{c.name}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.short_desc}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-10 text-center">
        <Button onClick={() => navigate("/plans")} data-testid="view-all-plans-btn"
          className="bg-slate-900 hover:bg-[#0E9AC8] text-white rounded-xl h-12 px-8 transition-colors">
          View All Plans <ArrowRight className="ml-2 h-4 w-4" strokeWidth={2} />
        </Button>
      </div>
    </section>
  );
}
